import React, { Component } from 'react';
import ErrorReload from '../ErrorReload/ErrorReload';

/**
 * Placeholder for a header element that failed to be loaded.
 */

 type Props = {
    message: string
    reverseOnMobile: boolean
    onReloadClick: () => void
}

class HeaderLoadErrorPlaceholder extends Component<Props> {
    componentDidMount() {
        window.scrollTo({ bottom: 1 } as ScrollToOptions);
    }

    render() {
        return (
            <ErrorReload {... this.props}></ErrorReload>
        );
    }
}

export default HeaderLoadErrorPlaceholder;